module.exports = __webpack_public_path__ + "img/rtv_logo_WH_3840x2160px-p-1080.2a04bae5.png";